<script>
import {fly} from 'svelte/transition';
import Demo from '../desktop/landingPage/sections/demo.svelte';
import Button from './button.svelte';
import TwitterBlogs from './twitterBlogs.svelte';
export let togglerclr = 'black';
export let bgclr = 'transparent';
let sideMenu;
let sideMenuInner;
let close;
let open;
let line;
let twitter;
let HeadingClass = 'heading1';
let visible = true;
let logoScale = 'logoScale';
const heading = [
    {
        heading: 'Gamers',
        top: '14.7vh',
        link: '/gamers',
    },
    {
        heading: 'Artists & Musicians',
        top: '20.9vh',
        link: '/artist',
    },
    {
        heading: 'Storytellers',
        top: '27vh',
        link: '/story',
    },
    {
        heading: 'Performers',
        top: '33vh',
        link: '/performance',
    },
];
const subHeading = [
    {
        text: 'Technical Creators',
        link: '/Create',
    },
    {
        text: 'Advertisers & Brands',
        link: '/AdvertPage',
    },
    {
        text: 'Investors',
        link: '/InvestPage',
    },
    {
        text: 'Team',
        link: '/Team',
    },
    {
        text: 'Careers',
        link: 'https://corp.opus.ai/jobs',
    },
];
    // let mainDiv;
    // let text;
    // let redDiv;
    // let imgClr = 'black';
    // let backclr = 'white';
export let borderclr =' black';
export let textclr =' black';
export let textClrAfter ='white';
export let bgClrAfter ='transparent';
let demoPage = 'demoPage';
</script>

<nav>
    <div class="mainDiv">
        <div
        role="presentation"
            class="logo"
            on:click={() => {
                location.href = '/';
            }}
        >
            <img class={logoScale} src="/images/opus_logo.svg" alt="" />
        </div>
       
        <div style="display:flex ;margin-right:-4.95vw;align-items: center;">
            {#if visible}
            <div
            role="presentation"
                class="btn" transition:fly="{{x: -1200, y: 600, duration: 1500}}"
                on:click={() => {
                    // location.href = '/demo';
                    demoPage = 'demoPageAfter';
                    visible =false;
                    logoScale = 'logoScaleAfter';
                }} 
                style="
            margin-right: 3.438vw;    position: relative;
            z-index: 0;cursor:pointer;"
            >
                <Button
                    {bgclr}
                    border="0.093vh solid {borderclr}"
                    color={textclr}
                    bgclrHover={bgClrAfter}
                    colorHover={textClrAfter}
                />
            </div>
            {/if}
            <div
            role="presentation"
                class="icon"
                bind:this={open}
                on:click={() => {
                    sideMenu.style.top = '0vw';
                    // sideMenu.style.left = '-1vw';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenuInner.style.top = '0vw';
                    sideMenuInner.style.left = '57.7vw';
                    sideMenuInner.style.transitionDuration = '1s';
                    close.style.visibility = 'visible';
                    close.style.opacity = '100%';
                    open.style.opacity = '0%';
                    open.style.visibility = 'hidden';
                    close.style.marginTop = ' 0vw';
                    close.style.marginRight = ' 6.5vw';
                    twitter.style.opacity= '1';
                }}
            >
                <svg
                    width="2.076vw"
                    height="2.348vw"
                    viewBox="0 0 40 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <line
                        x1="7.47363"
                        y1="2.5"
                        x2="37.4998"
                        y2="2.5"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="18.3438"
                        y1="15.1821"
                        x2="37.4997"
                        y2="15.1821"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="2.64258"
                        y1="27.8638"
                        x2="37.5"
                        y2="27.8638"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                </svg>
            </div>
            <div
            role="presentation"
                class="crossIcon"
                bind:this={close}
                on:click={() => {
                    sideMenu.style.left = '0vw';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenu.style.top = '-100vh';
                    sideMenuInner.style.left = '57.7';
                    sideMenuInner.style.transitionDuration = '1s';
                    sideMenuInner.style.top = '-100vh';
                    close.style.visibility = 'hidden';
                    close.style.opacity = '0%';
                    open.style.opacity = '100%';
                    open.style.visibility = 'visible';
                    open.style.marginRight = ' -4.5vw';
                    twitter.style.opacity= '0';
                }}
            >
                <img
                    src="/images/navbar/cross.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    </div>

    <div class="menu_back" bind:this={sideMenu}>
        <div class="twitterpage" bind:this={twitter}>
            <a class="twitter-timeline" data-theme="dark"  href="https://twitter.com/OpusAIInc?ref_src=twsrc%5Etfw">LATEST FROM TWITTER</a> 
        </div>
        <div class="twitter-blogs">
            <TwitterBlogs/>
        </div>
        
        <div class="menu_Section" bind:this={sideMenuInner}>
            <div class="line" bind:this={line} />
            <div class="Text">
                {#each heading as data, i}
                    <h3
                        role="presentation"
                        on:click={() => {
                            location.href = data.link;
                        }}
                        class={HeadingClass}
                        on:mouseenter={() => {
                            line.style.opacity = '1';
                            line.style.top = data.top;
                            HeadingClass = 'heading2';
                        }}
                        on:mouseleave={() => {
                            line.style.opacity = '0';
                            line.style.top = '4.4vw';
                            HeadingClass = 'heading1';
                        }}
                    >
                        {data.heading}
                    </h3>
                {/each}
                <hr class="hrcss" />
                <div style="margin-top: 3.241vh;">
                    {#each subHeading as data}
                        <p
                        role="presentation"
                            on:click={() => {
                                location.href = data.link;
                            }}
                        >
                            {data.text}
                        </p>
                    {/each}
                </div>
                <div style="margin-top: 8.594vw;" 
                role="presentation"
                on:click={() => {
                    demoPage = 'demoPageAfter';
                    sideMenu.style.left = '0vw';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenu.style.top = '-100vh';
                    sideMenuInner.style.left = '57.7';
                    sideMenuInner.style.transitionDuration = '1s';
                    sideMenuInner.style.top = '-100vh';
                    close.style.visibility = 'hidden';
                    close.style.opacity = '0%';
                    open.style.opacity = '100%';
                    open.style.visibility = 'visible';
                    open.style.marginRight = ' -4.5vw';
                    twitter.style.opacity= '0';
                }}>
                    
                    <Button
                    title = "Watch Demo"
                    {bgclr}
                    border="0.093vh solid {borderclr}"
                    color={textclr}
                    bgclrHover={bgClrAfter}
                    colorHover={textClrAfter}

                />
                </div>
                <div class="social_link" >
                    <div class="image">

                        <a rel="noreferrer" href="https://www.linkedin.com/company/opusai/" target="_blank">
                            <img src="/images/team/linkden.svg" alt="" width= "100%" height= 100%>
                        </a>
                    </div>    
                    <div class="image">
    
                        <a rel="noreferrer" href="https://www.youtube.com/c/opusai" target="_blank">
                            <img src="/images/team/youtube.svg" alt="" width= "100%" height= 100%>
                        </a>
                    </div>  
                    <div class="image">
    
                        <a rel="noreferrer" href="https://discord.com/invite/mEWEUkTFHh" target="_blank">
                            <img src="/images/team/discord.svg" alt="" width="100%" height="100%">
                        </a>
                    </div>  
                </div>
            </div>
        </div>
    </div>
    <div class={demoPage}>
        <Demo on:click={() => {
            demoPage = 'demoPage';
            visible = true;
            logoScale = 'logoScale';
        }}
        />
    </div>
</nav>

<style>
    .demoPage{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 100vh;
        transition: 1s;
    }
    .demoPageAfter{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0vh;
        transition: 1s;
        z-index: 10;
    }
    .twitter-blogs{
        overflow: hidden;
    }
    .social_link{
        display: flex;
        position: absolute;
        bottom: 2vw;
        width: 6vw;
        right: 0;
        left: 0;
        justify-content: space-between;
        margin-left: auto;
        margin-right: auto;
    }
    .image{
        width: 1.044vw;
    }
    /* .social_link1 {
            width: max(4vh, 21.6px);
            text-align: center;
            cursor: pointer;
            top: 45.9vw;
            left: 16.719vw;
            position: absolute;
    
    }
    .social_link2 {
            width: max(3.2vh, 21.6px);
    text-align: center;
    cursor: pointer;
    top: 45.9vw;
    left: 19.732vw;
    position: absolute;
    }
    .social_link3 {
        width: max(2.6vh, 21.6px);
    text-align: center;
    cursor: pointer;
    top: 45.9vw;
    left: 22.849vw;
    position: absolute;
    } */
    .twitterpage{
        width: 24vw;
        padding: 2vw 0vw 0vw 3vw;
        opacity: 0;
        height: 96vh;
        overflow: hidden;
        transition-duration: 1s;
    }
    .social1 {
        width: 1.8vw;
        height: 1.852vw; 
    }
    .third-btn {
        margin-right: max(4.63vh, 25px);
        width: 0vw;
        height: max(3.704vh, 20px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        cursor: pointer;
    }
    /* .third-btn p {
        font-size: max(1.296vh, 7px);
        font-weight: 700;
        color: transparent;
        margin-right: 2.5vw;
        position: absolute;
        left: 1vw;
        width: 7vw;
    } */
    .red-div {
        color: white;
        font-size: max(0.926vh, 5px);
        font-weight: 700;
        width: max(1.481vh, 8px);
        height: max(1.481vh, 8px);
        background-color: red;
        border-radius: 100%;
        position: absolute;
        right: -0.4vw;
        top: -0.5vw;
        text-align: center;
        border-radius: 100%;
        box-sizing: border-box;
        padding-right: 0.1vw;
    }
    .line {
        border-left: 0.3vw solid rgb(0, 0, 0);
        height: 1.3vw;
        position: relative;
        top: 6vh;
        left: 5vh;
        width: 0.1vw;
        opacity: 0;
        transition-duration: 1s;
    }
    nav {
        font-family: "Orbitron";
    }
    .logo {
        width: max(16.481vh, 89px);
        height: max(6.852vh, 37px);
        background-color: black;
        border-radius: 0 0.926vh 0.926vh 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 2;
    }
    .mainDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: max(3.704vh, 20px);
    }
    .logoScale {
        width: max(9.537vh, 51.5px);
        transition: 1.2s;
    }
    .logoScaleAfter{
        width: max(9.537vh, 51.5px);
        scale: 2.2;
        transition: 1s;
        margin-left: 5vw;
    }
    .icon {
        padding-right: 2.604vw;
        visibility: visible;
        opacity: 100%;
        transition-duration: 1s;
        cursor: pointer;
    }
    .crossIcon {
        width: max(3.5vh, 14.5px);
        height: max(3.5vh, 14.5px);
        float: right;
        margin-right: 6.63vh;
        visibility: hidden;
        opacity: 0%;
        z-index: 5;
        transition-duration: 1s;
        margin-top: -2.3vw;
        cursor: pointer;
    }
    .menu_back {
        background-image: url("images/navbar/bgcover.png");
        position: relative;
        background-color: black;
        /* background-image: url(/images/navbarpic.png);
        background-size: cover;
        background-position: center; */
        /* background-color: aqua; */
        position: absolute;
        height: 100vh;
        width: 57.7vw;
        left: 0vh;
        top: -100vh;
        transition-duration: 1s;
        z-index: 2;
        overflow: hidden;
        display: flex;
    }
    .menu_Section {
        overflow: hidden ;
        position: fixed;
        height: 100vh;
        width: max(42.365vw, 387.5px);
        background-color: #ffffff;
        z-index: 3;
        right: 0vw;
        cursor: pointer;
        left: 60vw;
        top: -100vh;
    }

    p,
    h3 {
        margin: 0;
    }
    .Text {
        margin: 11.389vh 10.185vh 0vw;
    }
    .heading2 {
        font-weight: 400;
        font-size: 2.15vw;
        line-height: max(4.63vh, 25px);
        color: grey;
        padding-bottom: 1.389vh;
        transition-duration: 1s;
    }
    .heading1 {
        font-weight: 400;
        font-size: 2.15vw;
        line-height: max(4.63vh, 25px);
        color: black;
        padding-bottom: 1.389vh;
        transition-duration: 1s;
    }
    .heading2:hover {
        font-weight: 900;
        color: #000000;
        transition-duration: 1s;
    }
    .heading1::first-letter {
        font-weight: 900;
    }
    .Text p {
        font-weight: 600;
        font-size: max(1.852vh, 10px);
        line-height: max(2.315vh, 12.5px);
        color: black;
        padding-bottom: 0.926vh;
    }
    .hrcss {
        width: max(56.296vh, 304px);
        border: 0.02vw solid #000000;
        margin: 0;
        background-color: black;
        margin: 3vw 0vw;
    }
    .join-btn {
        width: 8.958vw;
        height: 2.083vw;
        background: transparent;
        font-size: 0.729vw;
        font-weight: 700;
        border: 0.052vw solid black;
        font-family: "Orbitron";
        cursor: pointer;
        transition-duration: 1.3s;
    }
    .join-btn:hover {
        background-color: black;
        color: white;
    }
</style>
